import { Injectable } from '@angular/core';
import { LessonPagination } from '@df/interfaces/index';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MAIN_DOMAIN } from '@app/app.constants';

@Injectable()
export class LessonsListService {
    constructor(private http: HttpClient) {}

    getShortLessonsData(): Observable<Array<LessonPagination>> {
        return this.http.get<Array<LessonPagination>>(`${MAIN_DOMAIN}/api/lessons/_short`);
    }
}
